module.exports = __webpack_public_path__ + "img/full5-min.f16e5b04.png";